import { createContext, useCallback, useEffect, useState } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Components
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../app/common-components/CustomModal";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas";
import DrillDownOffCanvas from "../../../../app/common-components/DrillDown/DrillDownOffCanvas";
import Input from "../../../../app/common-components/form/input";
import Spinners from "../../../../app/common-components/Spinner";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice";
import { convertEpochToDate, useCommonAlert } from "../../../../app/utilities/helpers";
import { user } from "../../../../assets/images";

// Slice
import { configurationApi } from "../../../../app/services/configurationApi";
import { isLdapUserCheckAPI, ldapSyncAPI, userInfoListApi } from "../cmdb-overview/CMDBSlice";

// 3rd Party Libraries
import _, { get } from "lodash";
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

// Styles
import "../styles.scss";


export const ProjectContext = createContext();
const UserInfoConfig = () => {
  const dispatch = useDispatch();
  const{ userInfoListData,userInfoCountData,userInfoListLoading,userInfoCountLoading,isLdapUser,ldapSyncdata,ldapSyncdataFulFill, ldapSyncLoading }= useSelector((state) => state.cmdbId);
  const { userRole } = useSelector((state) => state.common.loggedUser);
  const notAllowedRoles = ["Application Manager", "Department Head", "Division Head"];
  const userAccess = !userRole.some(role => notAllowedRoles.includes(role));
  const [pageNo, setpageNo] = useState(0);
  const [pageLimit, setpageLimit] = useState(10);
  const [searchKey, setsearchKey] = useState("");
  const calculatedPageCount = userInfoListData.totalCount ? Math.ceil(userInfoListData.totalCount / pageLimit) : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;

  const [showServerForm, setShowServerForm] = useState(false);
  const [currentAction, setCurrentAction] = useState("");
  const [showUsername, setShowUserName] = useState("");
  const [showFullname, setShowFullName] = useState("");
  const [showEmail, setShowEmail] = useState("");
  const [getId, setGetId] = useState("");
  const [search, setSearch] = useState([]);
  const [showServerAddBtn, setShowServerAddBtn] = useState(true);
  const [Fields, setFields] = useState([]);
  const [showUsernameError, setShowUsernameError] = useState("");
  const [UsernameerrorMessage, setUsernameerrorMessage] = useState("");
  const [FnameerrorMessage, setFnameerrorMessage] = useState("");
  const [showFnameError, setShowFnameError] = useState("");
  const [showMailError, setshowMailError] = useState("");
  const [MailerrorMessage, setMailerrorMessage] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);

  const [Serverstate, setServerstate] = useState({
    applicationConfig: false,
    appConfigTitle: "",
    cmdbId: "",
    serverList: {},
  });
  // const [projectState, setProjectState] = useState({
  const { efficiency } = useSelector((state) => state);
  const userInfoData = get(efficiency, "appConfig.userInfoData", []);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const [state, setState] = useState({
    page: 0,
    limit: 10,
    tableData: [],
    count: 0,
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    fileInfo: "",
    fileError: "",
    loading:false,
    deleteModalOpen: false,
    loadPage: false,
    modalOpen: false,
    deleteId: "",
    userInfoTableData: [],
    UsernameInputState : false,
    FullnameInputState : false,
    EmailInputState : false,
    modalBodyTrigger:false,
    setImportOpen: false,
  });

  // const [getUserInfoCmdb] = configurationApi.useGetUserInfoCmdbMutation();
  const [getUserInfoSave] = configurationApi.useGetUserInfoSaveMutation();
  const [getUserInfoDelete] = configurationApi.useGetUserInfoDeleteMutation();

  const userInfoListData1 = state.userInfoTableData;
  const { state: locationState } = useLocation();

  const payloadid = locationState?.id;

  if (!payloadid) {
    // window.location.replace("/efficiency/appConfig");
  }

  const navigate = useNavigate();

  let userInfoData1 = "";

  userInfoData1 = userInfoListData1.data?.map((userinfo) => ({
    Username: userinfo.userName,
    FullName: userinfo.displayName,
    mail: userinfo.mail,
    accountCreatedDate: userinfo.accountCreatedOn,
    application: userinfo.application,
    addedOn: userinfo.addedOn,
    id: userinfo.payloadid,
  }));
  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // const convertEpochToDate = (givenDate) => {
  //   return (new Date(convertEpochTimeToMilliseconds(givenDate)).toLocaleString('en-IN', {
  //     day: '2-digit',
  //     month: '2-digit',
  //     year: 'numeric',

  //     hour12: false
  //   }));
  // }
  function convertEpochTimeToMilliseconds(epochTime) {
    if (epochTime > 1e12) {
      return epochTime;
    } else {
      const epochTimeInMilliseconds = epochTime * 1000;
      return epochTimeInMilliseconds;
    }
  }

  // const Headers = [
  //   {
  //     key: 1,
  //     text: "Username",
  //     value: "userName",
  //   },

  //   {
  //     key: 2,
  //     text: "Full Name",
  //     value: "displayName",
  //   },

  //   {
  //     key: 3,
  //     text: "Email ID",
  //     value: "mail",
  //   },

  //   {
  //     key: 4,
  //     text: "Created Date",
  //     value: "accountCreatedOn",
  //     component: (row) => (
  //       <div>
  //         {row.accountCreatedOn
  //           ? convertEpochToDate(row.accountCreatedOn)
  //           : "----"}
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   key: 5,
  //   //   text: "Added Date",
  //   //   value: "addedOn",
  //   //   component: (row) => (
  //   //     <div>{row.addedOn ? convertEpochToDate(row.addedOn) : "----"}</div>
  //   //   ),
  //   // },
  //   {
  //     key: 6,
  //     text: "Application Name",
  //     value: "application",
  //     component: (row) => (
  //       <div>{row.application ? row.application : "----"}</div>
  //     ),
  //   },

  //   {
  //     key: 7,
  //     text: "Action",
  //     value: "Action",
  //     component: (row) => (
  //       <div className="Servertdactions">
  //         {" "}
  //         {/* <div className="actcol p-0" style={{ width: '0%', margin: "0px 30px 0px 0px" }}>
  //           <a
  //             title="Edit"
  //             onClick={() => {
  //               setServerstate((state) => ({
  //                 ...state,
  //                 applicationConfig: true,
  //                 appConfigTitle: "Application",
  //                 editId: row.id,
  //               }));
  //             }}
  //           >
  //             <span>Edit</span>
  //             <img src={editIcon} onClick={() => openserver("edit", row.id)} />
  //           </a>
  //         </div> */}
  //         <div className="actcol p-0" style={{ width: "0%" }}>
  //           <a
  //             title="Delete"
  //             onClick={() => {
  //               setState((state) => ({
  //                 ...state,
  //                 modalOpen: true,
  //                 deleteId: row.id,
  //               }));
  //               // deleteId(row.id);
  //             }}
  //           >
  //             {/* <span>Delete</span> */}
  //             <img src={deletedIcon} />
  //           </a>
  //         </div>
  //       </div>
  //     ),
  //   },
  // ];

  const columns = [
    {
      Header: "User",
      accessor: "userName",
      Cell: ({ row }) => {
        const imageUrl = row?.original.imageUrl;
        const userImage = imageUrl
          ? `data:image/jpeg;base64,${imageUrl}`
          : user; // fallback image
        const hasImage = !!imageUrl;

        const renderTooltip = (props) => (
          <Tooltip id="user-tooltip" {...props} className="bg-white">
            <div className="d-flex flex-column align-items-center bg-white">
              <img
                src={userImage}
                alt="User Preview"
                className="popup-image mb-1"
                style={{ width: "80px", height: "80px", objectFit: "cover" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = user;
                }}
              />
              <div>{row?.original?.userName || "Unknown User"}</div>
            </div>
          </Tooltip>
        );

        return (
          <div className="d-flex align-items-center">
            {hasImage ? (
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <div className="image-wrapper position-relative">
                  <img
                    src={userImage}
                    alt="User Profile"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = user;
                    }}
                    className="profile-image me-1"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                    }}
                  />
                </div>
              </OverlayTrigger>
            ) : (
              <img
                src={userImage}
                alt="User Profile"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = user;
                }}
                className="profile-image me-1"
                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
              />
            )}
            {row?.original?.userName || "-"}
          </div>
        );
      },
    },
    {
      Header: "Full Name",
      accessor: "displayName",
    },

    {
      Header: "Email ID",
      accessor: "mail",
    },

    {
      Header: "Created Date",
      accessor: "accountCreatedOn",
      tdClassName: "text-center",
      Cell: ({ row, value }) => (
        <div>{value ? convertEpochToDate(value) : "----"}</div>
      ),
    },
    // {
    //   Header: "Added Date",
    //   accessor: "addedOn",
    //   Cell: ({row, value}) => (
    //     <div>{value ? convertEpochToDate(value) : "----"}</div>
    //   ),
    // },
    {
      Header: "Application Name",
      accessor: "application",
      Cell: ({ row, value }) => {
        if (Array.isArray(value)) {
          return <>{value.length !== 0 ? value.join(", ") : "-"}</>;
        } else {
          return <>{value ? value : "-"}</>;
        }
      },
    },

    {
      Header: "Action",
      accessor: "Action",
      tdClassName: "text-center",
      className: "text-center",
      thclassname: "text-center",
      disableSortBy: true,

      Cell: ({ row }) => (
        <div className="actionsBtn d-flex justify-content-center">
          {" "}
          {/* <div className="actcol p-0" style={{ width: '0%', margin: "0px 30px 0px 0px" }}>
            <a
              title="Edit"
              onClick={() => {
                setServerstate((state) => ({
                  ...state,
                  applicationConfig: true,
                  appConfigTitle: "Application",
                  editId: row.id,
                }));
              }}
            >
              <span>Edit</span>
              <img src={editIcon} onClick={() => openserver("edit", row.id)} />
            </a>
          </div> */}
          <div className="actcol p-0">
            <FiTrash2
              title="Delete"
              data-testid={"deleteIcon"}
              className="iconStyleActions"
              onClick={() => {
                if (userAccess) {
                  setState((state) => ({
                    ...state,
                    modalOpen: true,
                    deleteId: row.original.id,
                  }));
                }
              }}
            />
          </div>
        </div>
      ),
    },
  ];

  const payload = { 
    "keyword":searchKey
  };

  const userInfoTable = () => {
    dispatch(userInfoListApi({ pageNumber: pageNo, itemsPerPage: pageLimit,payload }));
    // getUserInfoCmdb()
    //   .unwrap(setState((state) => ({
    //     ...state,
    //     loading: true,
    //   })))
    //   .then((data) => {
    //     const sortedData = [...data].sort(
    //       (a, b) => b.accountCreatedOn - a.accountCreatedOn
    //     );
    //     setState((state) => ({
    //       ...state,
    //       loading:false,
    //       userInfoTableData: sortedData,
    //     }));
    //   });
  };

  useEffect(() => {
    userInfoTable();
  }, [pageNo,pageLimit,searchKey]);
  useEffect(() => {
    dispatch(isLdapUserCheckAPI());
  }, []);

  useEffect(() =>{
    if(ldapSyncdata=="LDAP users synchronized and saved successfully." && ldapSyncdataFulFill){
      callCommonAlert("success", "LDAP users synchronized and saved successfully.");
      setState((state) => ({
        ...state,
        modalOpen1: false,
        modalBodyTrigger: false
      }));
      userInfoTable();
      hideCommonAlert();
    }
    else if(ldapSyncdata=="Failed to synchronized." && ldapSyncdataFulFill){
      callCommonAlert("error", "Something went wrong. Please try again");
      setState((state) => ({
        ...state,
        modalOpen1: false,
        modalBodyTrigger: false
      }));
      hideCommonAlert();
    }
  },[ldapSyncdataFulFill]
  );
  const handleSaveAdd = () => {
    let hasError = false;
    function validateEmail(email) {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return emailRegex.test(email);
      }

    function validateUsername(username) {
        const usernameRegex =/^[a-zA-Z][a-zA-Z0-9_]+$/;
        return usernameRegex.test(username);
      }
    function validateFullname(fullname) {
        const fullnamenameRegex = /^[a-zA-Z][a-zA-Z0-9_]+$/;
        return fullnamenameRegex.test(fullname);
      }
  
    if (showUsername.trim() === '') {
      setUsernameerrorMessage('Username should not be empty');
      setShowUsernameError(true);
      setState({
        ...state,
        UsernameInputState: true,
      });
      hasError = true; 
    }
    else if (!validateUsername(showUsername)) {
      // Check for valid email
      setUsernameerrorMessage('Please enter a valid UserName');
      setShowUsernameError(true);
      setState({
        ...state,
        UsernameInputState: true,
      });
      hasError = true; 
    }

      else {
        setShowUsernameError(false);
        setState({
          ...state,
          UsernameInputState:false,
        });
        hasError = false;
      }

    if (showFullname.trim() === '') {
      setFnameerrorMessage('Fullname should not be empty');
      setShowFnameError(true);
      setState({
        ...state,
        FullnameInputState: true,
      });
      hasError = true; 
    }
    else if (!validateFullname(showFullname)) {
      // Check for valid email
      setFnameerrorMessage('Please enter a valid FullName');
      setShowFnameError(true);
      setState({
        ...state,
        FullnameInputState: true,
      });
      hasError = true; 
    }
    else {
      setShowFnameError(false);
      setState({
        ...state,
        FullnameInputState: false,
      });
      hasError = false; 
    }


    if (showEmail.trim() === '') {
      setMailerrorMessage('Email should not be empty');
      setshowMailError(true);
      setState({
        ...state,
        EmailInputState: true,
      });
      hasError = true; 
    } 
     else if (!validateEmail(showEmail)) {
      // Check for valid email
      setMailerrorMessage('Please enter a valid Mail');
      setshowMailError(true);
      setState({
        ...state,
        EmailInputState: true,
      });
      hasError = true; 
    }  
    else{
      setshowMailError(false);
      setState({
        ...state,
        EmailInputState: false,
      });
      hasError = false; 
    }
    if (!hasError){
    const payload = {
      displayName: showFullname,
      mail: showEmail,
      username: showUsername,
    };

    try {
      getUserInfoSave(payload)
        .then((data) => {
          if (data.error && data.error.data == "Saved Successfully") {
            callCommonAlert("success", "User saved successfully");
            setState((state) => ({
              ...state,
              modalOpen1: false,
            }));
            dispatch(
              setIsOffCanvasOpen({
                isDrilldownOpen: false,
                isDropDownhide: false,
              })
            );
            addserverclose();
            resetInput();
            // fetchData();
            userInfoTable();
            hideCommonAlert();
          }
          else if(data.error && data.error.data == "UserDetails Already Exist"){
            callCommonAlert("warning", "Username already exists");
          hideCommonAlert();
          }
          else {
            callCommonAlert("error", "Something went wrong. Please try again.");
            setState((state) => ({
              ...state,
              modalOpen1: false,
            }));
            hideCommonAlert();
          }
        });
    } catch (error) {
      console.log(error);
    }
  }
  };
  const handleSaveEdit = () => {
    const payload = {
      displayName: showFullname,
      mail: showEmail,
      username: showUsername,
      id: parseInt(getId),
    };
    try {
      getUserInfoSave(payload).then((data) => {
        if (data.error && data.error.data == "Updated Successfully") {
          callCommonAlert("success", "User Updated Successfully");
          setState((state) => ({
            ...state,
            modalOpen1: false,
          }));
          dispatch(
            setIsOffCanvasOpen({
              isDrilldownOpen: false,
              isDropDownhide: false,
            })
          );
          addserverclose();
          userInfoTable();
          hideCommonAlert();
        }
      });
    } catch (error) {
      // console.error(error);
    }
  };

  const deleteId = (id) => {
    setDeleteLoader(true);
    getUserInfoDelete({ id : state.deleteId })
      .then((data) => {
        if (data.data.statusCodeValue == 200) {
          setpageNo(0);
          callCommonAlert("success", data.data.body);
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          userInfoTable();
          setDeleteLoader(false);
          hideCommonAlert();
        }else if(data.data.statusCodeValue == 400){
          callCommonAlert("error", data.data.body);
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          setDeleteLoader(false);
          hideCommonAlert();
        }
      });
  };
  const UserInfoSave = useCallback(async () => {
    if (currentAction === "edit") {
      handleSaveEdit();
    } else {
      handleSaveAdd();
    }
  });

  const handleUsername = (e) =>{
    setShowUserName(e.target.value);
    setShowUsernameError(false);
  };
  const handleFullName = (e) =>{
    setShowFullName(e.target.value);
    setShowFnameError(false);
  };
  const handleEmail = (e) =>{
    setShowEmail(e.target.value);
    setshowMailError(false);
  };
  const isDisabled = () => {
    if (!showUsername || !showFullname || !showEmail) {
      return true;
    }
    return false;
  };

  const resetInput = () => {
    setShowUserName("");
    setShowFullName("");
    setShowEmail("");
    setGetId("");
  };

  const addserverclose = async () => {
    dispatch(hideOffCanvas(false));
    setshowMailError(false);
    setShowFnameError(false);
    setShowUsernameError(false);
    // setShowServerAddBtn(true)
    // setShowServerForm(false)
    // setFields(Fields.slice(0, -40));
    // setFields(fields.slice(0, -40));
  };

  const onDeleteData = (data) => {
    setState((state) => ({
      ...state,
      projectId: data.id,
      deleteModalOpen: true,
    }));
  };

  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
    hideCommonAlert();
  };

  const modalBody = () => (
    <>
      <h4 className="delete-h">Delete User Info</h4>
      {deleteLoader? (
        <Spinners/>
      ):(
        <>
          <p>
            Are you sure you would like to delete the User Info Configuration?
          </p>
          <div className="btnswrap btn-dlt">
            <ButtonComponent
            className={"cancelBtnStyle"}
            text="Cancel"
            onClick={handleClose}
            />
            
            <ButtonComponent
            className={"btnStyle"}
            text="Delete"
            onClick={deleteId}
            />
          </div>
        </>
      )}
    </>
  );

  const openserver = async (status, id) => {
    setShowUserName("");
    setShowFullName("");
    setShowEmail("");
    setGetId("");
    setshowMailError(false);
    setShowFnameError(false);
    setShowUsernameError(false);
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
    // setShowServerForm(!showServerForm);
    // setShowServerAddBtn(false);
    // if (status == 'edit') {
    //     getBusinessEdit(id)
    //         .unwrap()
    //         .then((responseData) => {
    //             console.log('Success Data:', responseData);
    //             setShowApplicationCode(responseData.appCode)
    //             setShowBusinessDepartment(responseData.businessDepartment)
    //             setShowBusinessCapability(responseData.businessCapablity)
    //             setShowBusinessActivity(responseData.businessActivity)
    //             setShowBusinessSubActivity(responseData.businessSubActivity)
    //             setGetId(responseData.id)
    //             setCurrentAction("edit");
    //         })
    // } else {
    //     setShowApplicationCode('')
    //     setShowBusinessDepartment('')
    //     setShowBusinessCapability('')
    //     setShowBusinessActivity('')
    //     setShowBusinessSubActivity('')
    //     setCurrentAction("add");
    // }
    // setShowServerForm(true)
    // setShowServerAddBtn(false)
  };
  const clickbtn = () => {
      return openserver("add", 0);
  };
  const handleSync = () => {
    dispatch(ldapSyncAPI()).then((data) => {
      console.log(data); 
        if (data.payload.statusCodeValue === 200) {
          setpageNo(0);
          callCommonAlert("success",  _.get(data, "payload.body") ? data.payload.body : "LDAP synchronization successful");
          setState((state) => ({
            ...state,
            modalBodyTrigger: false,
          }));
          userInfoTable();
          hideCommonAlert();
        } else if (data.payload.statusCodeValue === 400) {
          setpageNo(0);
          callCommonAlert("error", _.get(data, "payload.body") ? data.payload.body : "Something went wrong. Please try again");
          setState((state) => ({
            ...state,
            modalBodyTrigger: false
          }));
          userInfoTable();
          hideCommonAlert();
        } else if(data.error){
          callCommonAlert("error", data ? data.errorMessage : "Something went wrong please try again");
          setState((state) => ({
            ...state,
            modalBodyTrigger: false,
          }));
          hideCommonAlert();
        }
      });
  };
  const handleSyncConfirm = () => {
      setState({
        ...state,
        modalBodyTrigger: true,
      });
  };
  const handleTriggerClose = () => {
    setState({
      ...state,
      modalBodyTrigger: false,
    });
  };
  const modalBodyTrigger = () => (
    <>
      {ldapSyncLoading ? (
        <Spinners />
      ) : (
        <>
          <h4 className="delete-h">Sync LDAP</h4>
          <p>
            Are you sure you want to synchronize the LDAP users with exora?
          </p>
          <div className="btnswrap btn-dlt">
            <ButtonComponent
              text="Cancel"
              className="cancelBtnStyle gray btn"
              data-testid="cancel-trigger-btn"
              onClick={() => {
                handleTriggerClose();
              }}
            />
            <ButtonComponent
              text="Trigger"
              className="btnStyle btn btn-primary"
              data-testid="trigger-sync-btn"
              onClick={() => {
                handleSync();
              }}
            />
          </div>
        </>
      )}
    </>
  );
  const handleclickImport = () => {
    setState((state) => ({
      ...state,
      setImportOpen: true,
      file: '',
      fileInfo: '',
      fileError: '',
    }));
  };
  const importModalClose = () => {
    setState((state) => ({
      ...state,
      setImportOpen: false,
      fileError: '',
    }));
  };
  const importModal = () => (
    <>
      <h4>Import Users</h4>
      <div className="errors">{state.fileError}</div>
      <form id="upload-file-form" className="hide-ele">
        <div className="col-lg-12 upload-file-model">
          <label
            className="btn btn-submit chaos-btn ml-0 upload_btn"
            htmlFor="upload-file-input"
          >
            <input
              id="upload-file-input"
              data-testid="upload-file-input"
              type="file"
              accept=".csv"
              name="file"
              className="hide-ele"
              onChange={(event) => {
                setState({
                  ...state,
                  file: event.target.files[0] ? event.target.files[0] : "",
                  fileInfo: event.target.files[0].name? event.target.files[0].name : "",
                  fileError: "",
                });
              }}
            />
          </label>
          <span className="label label-default hide filepath" id="upload-file-info">
            {state.fileInfo !== ""
              ? "C:\\fakepath\\" + `${state.fileInfo? state.fileInfo : 'users'}`
              : ""}
          </span>
          <div className="col-md-12 upload_file pl-0">
            <a>Users.csv</a>
          </div>
        </div>
      </form>
      <div className="btnswrap">
        <ButtonComponent text="Cancel" onClick={importModalClose} className="cancelBtnStyle" data-testid="cancel-import-btn"/>
        <ButtonComponent text="Submit" onClick={importModalClose} data-testid="submit-import-btn"/>
       
      </div>
    </>
  );

  const btnData = isLdapUser
  ? [
    {
      text: "Sync LDAP",
      function: handleSyncConfirm,
      className: !userAccess ? "accessDisabled" : "solid-btn",
      disabled : !userAccess,
    },
    // {
    //   text: "Import CSV",
    //   function: handleclickImport,
    //   className: !userAccess ? " accessDisabled" : "solid-btn",
    //   disabled : !userAccess
    // },
  ]
  : [
    {
      text: "Add",
      function: clickbtn,
      className: !userAccess ? "accessDisabled" : "solid-btn",
      disabled : !userAccess,
    },
    {
      text: "Import CSV",
      function: handleclickImport,
      disabled : !userAccess
    },
  ];

  function getLimit(limit) {
    setpageLimit(limit);
    setpageNo(0);
  }
  function getPage(pageNo) {
    setpageNo(pageNo);
  }
  function getSearchKey(key) {
    setpageNo(0);
    setpageLimit(10);
    setsearchKey(key);
  }
  return (
    <>
      <CustomModal
          modalOpen={state.modalBodyTrigger}
          modalBody={modalBodyTrigger}
          modalHide={handleTriggerClose}
          closeBtn={false}
          closeBtnFuc={handleTriggerClose}
        />
      <CustomModal
        modalOpen={state.setImportOpen}
        modalBody={importModal}
        modalHide={importModalClose}
        closeBtn={true}
        closeBtnFuc={importModalClose}
      />
      <ProjectContext.Provider value={{ state, setState }}>
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          modalTitle={"Delete Configuration"}
          closeBtn={false}
          closeBtnFuc={handleClose}
        />
        <DrillDownOffCanvas
          customClass={"flowblock toolwrap custom_scroll"}
          subHeading={"Please enter your Project data."}
        />
      </ProjectContext.Provider>
      <div>
        <div className="btnwrap d-flex justify-content-between m-0">
          <div className="d-flex justify-content-end">
            
            <div className="mr-23">
             
            </div>
          </div>
        </div>
        <CustomOffCanvas className="custom-off-canvas">
          <h3 className="flowhead" id="updatehead" style={{ display: "block" }}>
            {currentAction === "edit" ? "Update User Info" : "Add New User"}{" "}
          </h3>
          {/* <div className="frmgroup default-input">
                <label>Username</label>
                <TypeaheadInput
                  id="uID"
                  options={search}
                  placeholder={"Enter User Name"}
                  onSearch={(searchString) =>
                    handleSearch(searchString, state.userDetails)
                  }
                  selected={state?.uID}
                  // autoComplete={"off"}
                  error={state.error}
                  onChange={(value) => handleOnChange("uID", value)}
                  errorMessage={state.errorMessage}
                  isDisabled={state.disabled}
                />
              </div>
              <div className="frmgroup default-input">
                <label>Full Name</label>
                <input
                  type="text"
                  id="usegroup1"
                  value={state?.displayName}
                  name={"fullName"}
                  placeholder={"Full Name"}
                  autoComplete={"off"}
                  disabled={true}
                  label={"Full Name"}
                />
                <br />
                <label>Email</label>
                <input
                  type="text"
                  id="user2"
                  value={state?.mail}
                  name={"email"}
                  placeholder={"Email"}
                  inputClassName={"user-email"}
                  autoComplete={"off"}
                  disabled={true}
                  label={"Email"}
                />
              </div> */}
              <Row classNmae="m-0">
                <Col>
               {/* <div className="mb-3">
              <label className="form-label">Username</label>
              <input type="text" list="serverlistdatalist" name={"UserName"} id="uID" className="form-control" placeholder="Enter Username" value={showUsername} onChange={e => setShowUserName(e.target.value)} maxLength="50" />
              <ServerListDataList />
            </div> */}
              <Input
                type="text"
                label="Username"
                name="Username"
                id="uID"
                error={showUsernameError}
                errorMessage={UsernameerrorMessage}
                placeholder="Enter Username"
                autoComplete={"off"}
                onChange={handleUsername}
                containerClassName={"frmgroup validate default-input"}
                value={showUsername}
                maxLength="50"
              />
            </Col>
            <Col>
            {/* <div className="mb-3">
              <label className="form-label">Full Name</label>
              <input type="text" list="serverlistdatalist" name={"fullName"} id="usegroup" className="form-control" placeholder="Enter Full Name" value={showFullname} onChange={e => setShowFullName(e.target.value)} maxLength="50" />
              <ServerListDataList />
            </div> */}
              <Input
                type="text"
                label="Full Name"
                name="fullName"
                id="usegroup"
                error={showFnameError}
                errorMessage={FnameerrorMessage}
                list="serverlistdatalist"
                placeholder="Enter Full Name"
                autoComplete={"off"}
                onChange={handleFullName}
                containerClassName={"frmgroup validate default-input"}
                value={showFullname}
                maxLength="50"
              />
            </Col>
            </Row>
            <Row classNmae="m-0">
              <Col>
            {/* <div className="mb-3">
              <label className="form-label">Mail</label>
              <input type="text" list="serverlistdatalist" name="email" id="user2" className="form-control" placeholder="Enter Mail Id" value={showEmail} onChange={e => setShowEmail(e.target.value)}  maxLength="50" autoComplete="off" />
              <ServerListDataList />
            </div> */}
              <Input
                type="text"
                label="Email ID"
                name="email"
                id="user2"
                error={showMailError}
                errorMessage={MailerrorMessage}
                placeholder="Enter Email ID"
                autoComplete={"off"}
                onChange={handleEmail}
                containerClassName={"frmgroup validate default-input"}
                value={showEmail}
                maxLength="50"
              />
            </Col>
            <Col></Col>
          </Row>
        <Row>
          <Col></Col> 
          <Col>
          <div
            className="server-btn"
            style={{ display: "block", justifyContent: "end" }}
          >
            <button
              className="cancelBtnStyle btn btn-primary"
              onClick={() => {
                addserverclose(), resetInput();
              }}
            >
              Cancel
            </button>
            {/* {currentAction === "edit" ? ' ' : <button className="solid-btn svebusiness" onClick={() => resetInput()}>Reset</button>} */}
            {/* <button className="solid-btn" onClick={() => submitSave()} disabled={isDisabled()}>Submit</button> */}
            {/* <Button variant="primary" size="sm" className="solid-btn px-4" onClick={() => {UserInfoSave(), resetInput(),addserverclose()}} disabled={isDisabled()}> {currentAction === "edit" ? " Save " : " Save "}</Button>{' '} */}
            {/* {!showUsername || !showFullname || !showEmail ? (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Please fill all the above fields</Tooltip>}
              >
                <button
                  className="btnStyle btn btn-primary"
                  onClick={() => {
                    UserInfoSave(), resetInput(), addserverclose();
                  }}
                  disabled={isDisabled}
                >
                  Save
                </button>
              </OverlayTrigger>
            ) : (
              <button
              className="btnStyle btn btn-primary"
              onClick={() => {
                  UserInfoSave(), resetInput(), addserverclose() , validation();
                }}
              >
                Save
              </button> */}
            {/* )} */}
            <ButtonComponent text="Save" data-testid="save-user-info-btn" onClick={() => { UserInfoSave(); }} />
          </div>
          </Col>
          </Row>
        </CustomOffCanvas>
        <div className="btnwrap d-flex m-0">
      </div>

        <div className="row">
          <div
            id="tableCol"
            style={{
              marginRight: showServerForm ? "75%" : "0",
              width: showServerForm ? "75%" : "100%",
            }}
          >
            <div className="grid-table">
            {/* {userInfoListLoading || userInfoCountLoading ? (
                <Spinners/>
              ):( */}
                <>
              {/* <Tablepaginate
                headers={Headers}
                hasAction
                body={state.userInfoTableData}
                isPagination={true}
                count={state.count}
                onPageChange={(page) => setState({ ...state, page })}
                onGetLimit={(limit) => setState({ ...state, limit, page: 0 })}
                currentPage={state.page}
                onDelete={onDeleteData}
                Btnadd={!showServerForm ? Btnadd : null}
                limit={10}
              /> */}
                    <CompleteTableData
                    isLoading={userInfoListLoading}
                      data={userInfoListData?.data || []}
                      columns={columns}
                      onPageLimitChange={getLimit}
                      onPageNoChange={getPage}
                      onSearch={getSearchKey}
                      curentPageNumber={pageNo}
                      pageLimit={pageLimit}
                      searchKey={searchKey}
                      totalPageCount={finalPageCount}
                      listCount={userInfoListData?.totalCount}
                      btnData={btnData}
                      moveSearchToEnd={true}
            />
            </>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserInfoConfig;
